import {createContext,useContext,useLayoutEffect,useState,type ReactNode} from 'react';
type Theme='dark'|'light';
const KEY='phasedrift.theme';
function savedTheme():Theme{try{return localStorage.getItem(KEY)==='light'?'light':'dark';}catch{return 'dark';}}
const ThemeContext=createContext<{theme:Theme;toggleTheme:()=>void}>({theme:'dark',toggleTheme:()=>{}});
export function ThemeProvider({children,value}:{children:ReactNode;value?:Theme}){
 const [saved,setTheme]=useState<Theme>(savedTheme);
 const theme=value??saved;
 useLayoutEffect(()=>{document.documentElement.dataset.theme=theme;try{localStorage.setItem(KEY,theme);}catch{}},[theme]);
 return <ThemeContext.Provider value={{theme,toggleTheme:()=>setTheme(current=>current==='dark'?'light':'dark')}}>{children}</ThemeContext.Provider>;
}
export const useTheme=()=>useContext(ThemeContext);
